function t(key: string, parameters?: unknown) {
  return parameters == null ? key : key + JSON.stringify(parameters);
}

const TRANSLATION_STUB = Object.assign([t], { t });

export const useTranslationStub: any = () => TRANSLATION_STUB;
